<!--
 * @Description: 分销商品管理
 * @Author: xiawenlong
 * @Date: 2022-01-19 10:27:27
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-01-19 10:27:27
-->
<template>
  <div class="dist-product">
    <table-list
      title="商品列表"
      :loading="loading"
      :data="dataList"
      :search-form="searchForm"
      :columns="columns(this)"
      :operates="operates(this)"
      :pager="pager"
      :btns="btns(this)"
      :options="{ selection: true, operatesWidth: 100 }"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
  </div>
</template>

<script>
import TableList from '@/components/TableList'
import {
  distributeProductList,
  distributeProductStatusUpdate,
  distributeProductExport,
} from '@/api/distribute'
import to from 'await-to'
// 导出按钮
const btns = _this => [
  {
    label: '导出',
    type: 'primary',
    method: _this.handleExport,
  },
]

// 搜索表单配置
const searchForm = [
  {
    label: '商品类型',
    prop: 'resourceType',
    type: 'select',
    clearable: true,
    children: [
      { value: 2, label: '课程' },
      { value: 3, label: '证书' },
    ],
  },
  {
    label: '商品名称',
    prop: 'name',
  },
  {
    label: '商品状态',
    prop: 'distributionFlag',
    type: 'select',
    clearable: true,
    children: [
      { value: false, label: '禁止分销' },
      { value: true, label: '允许分销' },
    ],
  },
  {
    label: '上架时间',
    prop: 'publishTime',
    type: 'picker',
  },
]

// 表格列配置
const columns = () => [
  {
    prop: 'pic',
    label: '商品封面',
    minWidth: 112,
    render: (h, { row }) => {
      return [
        h('img', {
          domProps: { src: row.pic },
          style: 'width:92px;height:56px;object-fit:cover;',
        }),
      ]
    },
  },
  {
    prop: 'name',
    label: '商品名称',
    minWidth: 160,
    twoLines: true,
  },
  {
    prop: 'resourceTypeName',
    label: '商品类型',
    minWidth: 90,
  },
  {
    prop: 'price',
    label: '价格',
    minWidth: 100,
    align: 'right',
    sortdata: 1,
    formatter: row => {
      return `￥${row.price}`
    },
  },
  {
    prop: 'sale',
    label: '销量',
    minWidth: 100,
    align: 'right',
    sortdata: 2,
  },
  {
    prop: 'createUserName',
    label: '创建人',
    minWidth: 90,
  },
  {
    prop: 'publishTime',
    label: '上架时间',
    minWidth: 160,
    sortdata: 3,
  },
  {
    prop: 'distributionFlag',
    label: '状态',
    minWidth: 100,
    render: (h, { row }) => {
      return h(
        'span',
        {
          style: {
            color: row.distributionFlag == true ? '#67C23A' : '#606266',
          },
        },
        { false: '禁止分销', true: '允许分销' }[row.distributionFlag],
      )
    },
  },
]

// 表格操作按钮配置
const operates = _this => [
  {
    label: '启用分销',
    type: 'text',
    color: '#409EFF',
    isShow: row => !row.distributionFlag,
    method: _this.handleEnable,
  },
  {
    label: '禁用分销',
    type: 'text',
    color: '#F56C6C',
    isShow: row => row.distributionFlag,
    method: _this.handleDisable,
  },
]

export default {
  name: 'DistProduct',
  components: {
    TableList,
  },
  data() {
    return {
      btns,
      searchForm,
      columns,
      operates,
      loading: false,
      dataList: [],
      queryParams: {},
      selectList: [],
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(distributeProductList({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.dataList = res.data.list || []
      this.pager.total = res.data.total || 0
    },
    onSearch(queryParams) {
      this.pager.current = 1
      if (queryParams.publishTime) {
        queryParams.publishStartTime = queryParams.publishTime[0]
        queryParams.publishEndTime = queryParams.publishTime[1].split(' ')[0] + ' 23:59:59'
      } else {
        queryParams.publishStartTime = ''
        queryParams.publishEndTime = ''
      }
      this.queryParams = queryParams
      this.getList()
    },
    async handleEnable(row) {
      const [, err] = await to(
        distributeProductStatusUpdate({ productId: row.productId, distributionFlag: true }),
      )
      if (err) return this.$message.warning(err.msg)
      this.$message.success('已启用分销')
      this.getList()
    },
    async handleDisable(row) {
      const [, err] = await to(
        distributeProductStatusUpdate({ productId: row.productId, distributionFlag: false }),
      )
      if (err) return this.$message.warning(err.msg)
      this.$message.success('已禁用分销')
      this.getList()
    },
    async handleExport() {
      let productIdList = []
      this.selectList.map(v => productIdList.push(v.productId))
      const { current, size } = this.pager
      const [res, err] = await to(
        distributeProductExport({ current, size, ...this.queryParams, productIdList }),
      )
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '商品列表.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    handleSelectionChange(val) {
      this.selectList = val
    },
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
.dist-product {
  height: 100%;
}
</style>
